// Deposit definitions per registration category / sub-type.
// The `lookup_key` matches the Stripe Price catalog set up in setup_stripe.py.

export const DEPOSITS = {
  performer: {
    lookup_key: "performer_deposit",
    amount_jpy: 30000,
    label: "Performer Deposit",
  },
  restaurant: {
    // Deposits vary by sub-type; RegistrationCard picks based on registration.data.booth_type
    variants: [
      {
        match: (d) => (d?.booth_type || "").toLowerCase().includes("food"),
        lookup_key: "food_booth_deposit",
        amount_jpy: 50000,
        label: "Food Booth Deposit",
      },
      {
        match: (d) => (d?.booth_type || "").toLowerCase().includes("catering"),
        lookup_key: "catering_deposit",
        amount_jpy: 40000,
        label: "Catering Booth Deposit",
      },
    ],
    // fallback
    default: {
      lookup_key: "food_booth_deposit",
      amount_jpy: 50000,
      label: "Food Booth Deposit",
    },
  },
  trader: {
    variants: [
      {
        match: (d) => (d?.booth_type || "").toLowerCase().includes("bring"),
        lookup_key: "bring_in_deposit",
        amount_jpy: 30000,
        label: "Bring-In Booth Deposit",
      },
      {
        match: (d) => (d?.booth_type || "").toLowerCase().includes("exhibition"),
        lookup_key: "exhibition_deposit",
        amount_jpy: 40000,
        label: "Exhibition Booth Deposit",
      },
    ],
    default: {
      lookup_key: "exhibition_deposit",
      amount_jpy: 40000,
      label: "Exhibition Booth Deposit",
    },
  },
  business_matching: {
    lookup_key: "business_matching_deposit",
    amount_jpy: 20000,
    label: "Business Matching Deposit",
  },
  sponsor: null, // Sponsors are contract-based, invoiced offline.
};

export function getDepositFor(registration) {
  const cfg = DEPOSITS[registration.category];
  if (!cfg) return null;
  if (cfg.variants) {
    const matched = cfg.variants.find((v) => v.match(registration.data));
    return matched || cfg.default || null;
  }
  return cfg;
}
